import { useAppSelector } from "@/redux/hooks";
import { Box, SxProps } from "@mui/material";
import { useCheckoutUI } from "../../CheckoutUIProvider";

export const BuyBoxRetailerTerms = ({ sx }: { sx?: SxProps }) => {
  const [state] = useCheckoutUI();
  const { checkoutIntent } = state.context;

  const currentRetailer = useAppSelector((state) => state.retailers).find(
    (item) => item.retailerId === checkoutIntent?.retailerId
  );
  const termsAndService = currentRetailer?.tosUrl;

  return (
    <Box
      component="p"
      sx={{
        fontSize: 14,
        fontWeight: 500,
        marginTop: 4,
        color: "primary.main",
        textAlign: "center",
        opacity: 0.3,
        ...sx,
      }}
    >
      By ordering, you agree to the {currentRetailer?.displayName}{" "}
      <a
        href={termsAndService?.terms}
        target="_blank"
        rel="noreferrer"
        className="tosLinks"
        style={{ color: "inherit" }}
      >
        Terms
      </a>{" "}
      and{" "}
      <a
        href={termsAndService?.policies}
        target="_blank"
        rel="noreferrer"
        className="tosLinks"
        style={{ color: "inherit" }}
      >
        Privacy Policy
      </a>
      .
    </Box>
  );
};
